import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  const navItems = [
    { label: t('nav.home'), path: '/' },
    { label: t('nav.celebrityGossip'), path: '/category/celebrity-gossip' },
    { label: t('nav.exclusiveScoop'), path: '/category/exclusive-scoop' },
    { label: t('nav.varietyHot'), path: '/category/variety-hot' },
    { label: t('nav.filmTvNews'), path: '/category/film-tv-news' },
    { label: t('nav.influencerNews'), path: '/category/influencer-news' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm">
              51
            </span>
            <span className={`font-heading font-bold text-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              吃瓜官网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-500/15 text-primary-600'
                    : scrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled || !isHome
                ? 'text-foreground-800 hover:bg-background-200'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-500/15 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500/15 text-primary-600'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}